/**
 * Shared Google Maps script loader.
 * Uses a named callback so we know exactly when the Maps API is fully ready.
 * The single module-level promise prevents duplicate script injection across
 * components (PublicShopMap, LocationPickerPage, ShopsMapPage, etc.).
 */

let _mapsPromise: Promise<void> | null = null

export function loadGoogleMaps(apiKey: string): Promise<void> {
  if (typeof google !== 'undefined' && google.maps && google.maps.Map) {
    return Promise.resolve()
  }
  if (_mapsPromise) return _mapsPromise

  _mapsPromise = new Promise<void>((resolve, reject) => {
    const cbName = `__googleMapsReady_${Date.now()}`
    ;(window as any)[cbName] = () => {
      delete (window as any)[cbName]
      resolve()
    }
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&callback=${cbName}`
    script.async = true
    script.defer = true
    script.onerror = () => {
      _mapsPromise = null
      delete (window as any)[cbName]
      reject(new Error('Failed to load Google Maps'))
    }
    document.head.appendChild(script)
  })

  return _mapsPromise
}
